import { render, staticRenderFns } from "./_visualtoken.vue?vue&type=template&id=d64ecc8c&scoped=true&v-slot%3Atop=true"
import script from "./_visualtoken.vue?vue&type=script&lang=js"
export * from "./_visualtoken.vue?vue&type=script&lang=js"
import style0 from "./_visualtoken.vue?vue&type=style&index=0&id=d64ecc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64ecc8c",
  null
  
)

export default component.exports